module.exports = __webpack_public_path__ + "img/arrow-up.2b6ec537.svg";